module.exports = __webpack_public_path__ + "static/media/placed.2cff59a2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/placed.webp
// module id = 541
// module chunks = 4